import moment from '@/moment-gp'
import clonedeep from 'lodash.clonedeep'
import SessionManagementMixin from "@/components/Mixins/SessionManagement"

import { mapActions } from "vuex";

export default {
  mixins: [SessionManagementMixin],
  props: {
  },
  computed: {
  },
  methods: {
    ...mapActions("dayplanner", [
      'setDragTargetDate',
      'setDragTargetIndex',
      'setDragTimeActive'
    ]),
    cloneItem(item) {
      let item_clone = clonedeep(item);
      item_clone.id = item_clone.$id;
      item_clone.groupId = item_clone.$groupId;
      delete item_clone.$key; /* remove key */
      delete item_clone.$id; /* remove key */
      delete item_clone.$groupId; /* remove key */
      item_clone.description = null; /* Remove description, so user can set it */
      item_clone.just_dropped = true;

      console.log("[DND] cloneItem", item_clone)
      let data = {
        tasks: [],
        dragConfig: {
          duration: 3600,
          shiftingEnabled: true,
          //minFrom ... earliest start date
          //maxTo ... latest end date
          //minDuration: val.to - val.from,
          placeAtEnd: false
        }
      }
      Object.assign(item_clone, data)
      console.log('cloneItem',item_clone)

      this.setDragItem(item_clone)
      this.setDragItemType('SESSION')
      return item_clone;
    },

    onNewItemDragMove($event) {
      // console.log('onDragMove', this.view_date_as_yymmdd, $event)
      // console.log('onDragMove', $event, $event.related, $event.draggedContext)

      let dateString = null
      let newIndex = null

      if ($event.related.attributes.getNamedItem('date-string')) {
        dateString = $event.related.attributes.getNamedItem('date-string').nodeValue
        // console.log('$event.draggedContext', $event.draggedContext,$event.related)
        newIndex = $event.draggedContext.futureIndex

        /*if (this.view_is_multi_day) {
          newIndex = newIndex - 1
        }*/

        if (dateString) {
          this.setDragTargetDate(dateString)
          this.setDragTargetIndex(newIndex)
          this.setDragTimeActive(true)
          //this.dragActive = true;
        }
      }

      //let cancelDrag = !Array.from($event.related.classList).includes("action-draggable--filtered");
      // console.log('onDragMove newIndex:', newIndex)
      if (!newIndex || this.drag_target_status_ok === false) {
        return false
      }
      // console.log('onNewItemDragMove SidebarMixin')
    },

    onAddSuggestionItem(groupId, item, $event = {}) {
      let item_clone = this.cloneItem(item);
      console.log('onAddItem', item_clone)

      if ($event.subtype === 'ADHOC_SESSION') {
        console.log('onAddSuggestionItem adding ADHOC_SESSION');
        item.type = 'TASKLIST'
        item.config = $event.config
        item.name = $event.name
        item.component = 'flow-tasklist'
      }

      if ( $event && $event.suggestedFrom ) {
        item_clone.devSuggestedFrom = moment.unix( $event.suggestedFrom ).format('LLL')
      }

      Object.assign(item_clone, $event);

      console.log("onAddSuggestionItem", item_clone, "$event ", $event);
      this.$emit("add", item_clone);
    },

    get_component_name( commitment ) {
      if ( commitment.type === 'TIME_BASED_TASKLIST' ) {
        return 'item-tasklist'; // TODO !!!!!
      }
      return 'item-' + commitment.type.toLowerCase()
    }
  },
}
